import { useTranslation } from 'react-i18next';
import CasAccordion from '@customer/components/accordions/accordion/CasAccordion';
import AccordionHeader from '@customer/components/accordions/header/AccordionHeader';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { DocumentFamily, DocumentProduct } from '@cas/config/documents';
import { ControlledAccordion } from '@customer/components/accordions/useControlledAccordions';
import { AccordionStatus } from '@customer/components/accordions/types';
import AccordionBody from '@customer/components/accordions/body/AccordionBody';

interface AccordionNotificationReleaseNoteProps {
  isNew: boolean;
  releaseDate: string;
  version: string;
  productFamilies: DocumentFamily[];
  products: DocumentProduct[];
  downloadUri: string;
  controlled?: ControlledAccordion;
}

export const AccordionNotificationReleaseNote = ({
  isNew,
  releaseDate,
  version,
  productFamilies,
  products,
  downloadUri,
  controlled,
}: AccordionNotificationReleaseNoteProps) => {
  const { t } = useTranslation();
  const { showDateOnlyFromIso } = useLocaleFormatter();

  const status: AccordionStatus = isNew ? AccordionStatus.Informative : AccordionStatus.Neutral;
  const dateDisplay = showDateOnlyFromIso(releaseDate);
  const productsDisplay = products.length
    ? `(${products.map(p => t('DocProduct.' + p)).join(', ')})`
    : '';
  const productFamiliesDisplay = productFamilies.length
    ? `${productFamilies.map(p => t('DocProductFamily.' + p)).join(', ')}`
    : '';
  const versionDisplay = `${t('Version')} ${version}`;
  const title = `${versionDisplay} - ${productFamiliesDisplay} ${productsDisplay}`;
  const subtitle = `${dateDisplay}, ${t('ReleaseNote')}`;
  const description = t('ReleaseNoteNotificationDescription');

  return (
    <CasAccordion
      status={status}
      icon="bell"
      controlled={controlled}
      header={<AccordionHeader title={title} subtitle={subtitle} />}
    >
      <AccordionBody
        title={subtitle}
        description={description}
        url={downloadUri}
        linkTitle={versionDisplay}
      />
    </CasAccordion>
  );
};

export default AccordionNotificationReleaseNote;
